import { api } from "./orgApi";

export async function getSmsSandboxStatus() {
  const { data } = await api.get("/admin/sms-sandbox-test");
  return data;
}

export async function sendSmsSandboxTest({ destinationPhoneNumber, message }) {
  const { data } = await api.post("/admin/sms-sandbox-test", {
    destinationPhoneNumber,
    message,
  });
  return data;
}
